<template>
	<div class="image-select-container">
		<div :class="['image-select-item', store.selectedImage == index ? 'image-select-item--active' : '']" v-for="(i, index) in images" v-bind:key="i">
			<img :src="require(`../assets/images/compare/${i.thumbnail}`)" @click="selectImage(index)">
		</div>
		<h3 v-for="(i, index) in images" v-bind:key="i">{{ index + 1 }}</h3>
	</div>
</template>

<script>
  	import { compareImages } from '../data.js'
	import { store } from '../store.js'

	export default {
		name: "ImageSelect",
		props: {
			value: {
			type: Number,
			default: 50,
			},
			beforeImage: {
			type: String,
			default: "",
			},
			afterImage: {
			type: String,
			default: "",
			},
			step: {
			type: Number,
			default: 0.1,
			},
		},
		data() {
			return {
				store,
				images: compareImages.images,
				isSelected: false
			};
		},
		mounted() {
		},
		destroyed() {
		},
		methods: {
			selectImage(index) {
				this.store.selectedImage = index
				this.isSelected = !this.isSelected;
			}
		},
	};
</script>
<style scoped>
.image-select-container {
	width: 100%;
	height: 85%;
	display: grid; 
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
}

img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.image-select-item {
	aspect-ratio: 1 / 1;
	overflow: hidden;
	border: 2px solid #ffffff;
	border-radius: 10%;
	/* height: 100%; */
	width: auto;
	transition: border 0.125s;
}

.image-select-container h3 {
	margin-top: 1rem;
	font-family: Magazine-Regular;
  	font-size: var(--font-size-two);
  	text-shadow: #000000 1px 1px 15px;
}

.image-select-item--active {
	border: 6px solid var(--yellow);
}
</style>